import Vue from 'vue';
import BzbsApi from "@/core/Http/BzbsApi.js";
export default {
    config: function () {
        return Vue.bzbsConfig;
    },
    getCampaign: function (token, listConfig) {
        var url = `${this.config().bzbsUrl}/api/campaign`;
        return BzbsApi.connectBzbsGet(url, token, listConfig)
    },
    getTotalRedemtion: function (token) {
        var t = new Date().getTime();
        var url = `${this.config().bzbsUrl}/modules/megabangna/profile/me/draw_history?token=${token}&t=${t}`;
        return BzbsApi.connectBzbsGet(url);
    },
    // redeemCampaign: function (token, campaignId, listConfig) {
    //     var url = Vue.bzbsConfig.bzbsUrl + "/api/campaign/" + campaignId + "/redeem";
    //     return BzbsApi.connectBzbsPost(url, token, params);
    // }

}
